import React, { useState } from 'react';
import { Building, Building2, Landmark } from 'lucide-react';

const BusinessTypeSelector = () => {
  const [selectedType, setSelectedType] = useState('small');

  const businessTypes = [
    {
      id: 'small',
      name: 'SMALL BUSINESS',
      icon: <Building className="w-5 h-5" />,
      description: 'Perfect for startups and small companies'
    },
    {
      id: 'mid',
      name: 'MID-SIZE BUSINESS',
      icon: <Building2 className="w-5 h-5" />,
      description: 'Ideal for growing companies'
    },
    {
      id: 'enterprise',
      name: 'ENTERPRISE',
      icon: <Landmark className="w-5 h-5" />,
      description: 'Comprehensive solutions for large organizations'
    }
  ];

  return (
    <div className="bg-red-600 py-8 md:py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-2xl lg:text-3xl font-bold text-white mb-4">
            Choose Your Business Type
          </h2>
          <p className="text-red-100 text-lg">
            Select the option that best describes your business to see tailored marketing solutions
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          {businessTypes.map((type) => (
            <button
              key={type.id}
              onClick={() => setSelectedType(type.id)}
              className={`w-full sm:w-auto min-w-[200px] bg-white rounded-lg px-6 py-4 flex items-center justify-center space-x-3 transition-all duration-300 ${
                selectedType === type.id
                  ? 'shadow-lg transform scale-105 border-2 border-red-300'
                  : 'shadow-md hover:shadow-lg hover:scale-105'
              }`}
            >
              <div className="text-red-600">
                {type.icon}
              </div>
              <span className="text-red-600 font-semibold text-sm uppercase">
                {type.name}
              </span>
            </button>
          ))}
        </div>

        {/* Información adicional basada en la selección */}
        <div className="mt-8 text-center">
          <p className="text-white text-lg">
            {businessTypes.find(type => type.id === selectedType)?.description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default BusinessTypeSelector;
